export default "__VITE_ASSET__d00a6c83__"